import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import tradeUnionReducer from "./tradeUnionReducer";
import sectorReducer from "./sectorReducer";
import branchReducer from "./branchReducer";
import gradeReducer from "./gradeReducer";
import memberReducer from "./memberReducer";
import institutionReducer from "./institutionReducer";
import securityReducer from "./securityReducer";
import batchReducer from "./batchReducer";
import siteReducer from "./siteReducer";
import receiptReducer from "./receiptReducer";
import billReducer from "./billReducer";
import exchangeRateReducer from "./exchangeRateReducer"
export default combineReducers({
    errors: errorReducer,
    tradeUnion:tradeUnionReducer,
    sector:sectorReducer,
    branch:branchReducer,
    grade:gradeReducer,
    member:memberReducer,
    institution:institutionReducer,
    security:securityReducer,
    batch:batchReducer,
    receipt:receiptReducer,
    bill:billReducer,
    exchangeRate:exchangeRateReducer,
    site:siteReducer
    
  });